import { TriangleAlert } from 'lucide-react'
import type { HTMLAttributes, ReactNode } from 'react'

export interface ErrorFieldProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode
}

export function ErrorField({ children, ...rest }: ErrorFieldProps) {
  return (
    <span
      {...rest}
      className="flex items-center justify-start gap-1 text-red-500"
    >
      <TriangleAlert size={18} className="fill-red-500 text-white" />
      {children}
    </span>
  )
}
